export default {
  one: {
    active: require("./../../../../../assets/img/ic_1.png"),
    text: "Cannot say",
    helper:"",
    des:""
  },
  two: {
    active: require("./../../../../../assets/img/ic_2.png"),
    text: "Strongly disagree",
    helper:"Slightly less",
    des:"Inadequate"
  },
  three: {
    active: require("./../../../../../assets/img/ic_3.png"),
    text: "Somewhat disagree",
    helper:"Equivalent",
    des:"Adequate"
  },
  four: {
    active: require("./../../../../../assets/img/ic_4.png"),
    text: "Somewhat agree",
    helper:"Slightly more",
    des:"Very good"
  },
  five: {
    active: require("./../../../../../assets/img/ic_5.png"),
    text: "Strongly agree",
    helper:"Excellent/Best",
    des:"Excellent"
  },
};
